import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { PageableResult } from "src/app/ui/models/domains/paginator/pageable-result";
import { UserPermissions } from "./../../../../models/domains/pbm/user/user-permissions";
import { UserService } from "src/app/ui/services/user.service";
import { MaskInput } from "src/app/ui/models/domains/masks/mask.model";
import { AppContext } from "src/app/ui/contexts/app-context";
import { FeatureViewService } from "src/app/ui/services/feature-view.service";
import { FeatureViews } from "src/app/ui/models/domains/features/custom-feature-views";
import { PagingRequest } from "src/app/ui/models/domains/paginator/paging-request";
import { PageViews } from "src/app/ui/models/domains/features/custom-page-views";
import { RoutePath } from "src/app/ui/models/domains/route-paths.model";
import { LoadingService } from "src/app/ui/services/loading.service";
import { CompanyService } from "src/app/ui/services/pbm/company.service";
import { UserProfile } from "src/app/ui/models/domains/pbm/user/user-profile";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { UntypedFormControl } from "@angular/forms";
import { ICompanyFilterParams } from "src/app/ui/models/domains/pbm/companies/company-filter-params";

@Component({
  selector: "search-financial-statement",
  templateUrl: "./search-financial-statement.component.html",
  styleUrls: ["./search-financial-statement.component.scss"],
})
export class SearchFinancialStatementComponent implements OnInit {
  filterText: string;
  pageableResult: PageableResult = new PageableResult();
  fiscalNumberMask = MaskInput.getFicalNumberMask();
  userProfile: UserProfile;
  searchType: UntypedFormControl;
  private searchCompanyFirst: boolean;

  constructor(
    private router: Router,
    private featureViewService: FeatureViewService,
    private loadingService: LoadingService,
    private companyService: CompanyService,
    private appContext: AppContext,
    private userService: UserService,
  ) {
    this.searchType = new UntypedFormControl(1);
  }

  ngOnInit() {
    this.featureViewService.activeFeatureView(FeatureViews.FinancialStatementSearchFeatureView, PageViews.FinancialStatementPageView);
    this.userProfile = this.userService.getUserProfile();
    this.searchCompanies(this.userProfile.getPreferences().getFilterText());
  }

  navigateToFinancialStatementCompany(fiscalNumber: string) {
    this.router.navigate([RoutePath.FinancialStatementCompany], { queryParams: { b: fiscalNumber } });
  }

  scrollToLastCompany() {
    const bottom = document.getElementById("bottom");
    bottom.scrollIntoView();
  }

  onPressEnterSearchCompanies(event): void {
    if (event.key === "Enter") {
      this.searchCompanies(this.filterText);
    }
  }

  searchCompanies(fiscalNumber: string) {
    const start = 1;
    const end = this.appContext.getTotalPerPage();
    this.searchCompanyFirst = true;
    this.doSearchCompany(start, end, fiscalNumber);
  }

  searchMoreCompanies() {
    this.searchCompanyFirst = false;
    const start = this.pageableResult.getEnd() + 1;
    const end = this.appContext.getTotalPerPage();
    this.doSearchCompany(start, end, this.userProfile.getPreferences().getFilterText());
  }

  private doSearchCompany(start: number, end: number, fiscalNumber: string): void {
    const pagingRequest = new PagingRequest();
    pagingRequest.setStart(start);
    pagingRequest.setEnd(end);
    const ref = this.loadingService.beginLoading();
    const filterParams: ICompanyFilterParams = {
      filterText: fiscalNumber ? fiscalNumber.replace(/[./-]/g, "") : "",
    };
    this.companyService
      .searchCompany(filterParams, pagingRequest)
      .then((pageableResult) => {
        this.pageableResult.setStart(start);
        this.pageableResult.setEnd(end);
        this.pageableResult.setTotalItems(pageableResult.getTotalItems());
        if (this.searchCompanyFirst) {
          this.pageableResult.setItems(pageableResult.getItems());
        } else {
          this.pageableResult.addItems(pageableResult.getItems());
        }
        this.storageSearchPreferences(fiscalNumber);
        this.filterText = "";
      })
      .catch((error) => {
        this.pageableResult.setItems(null);
      })
      .finally(() => {
        this.loadingService.finishLoading(ref);
      });
  }

  hasCompany(): boolean {
    return this.pageableResult.getItems().length > 0;
  }

  showScrollBottomBtn(): boolean {
    return this.pageableResult.getItems().length > 1;
  }

  showMoreCompaniesBtn(): boolean {
    return this.pageableResult.getTotalItems() !== this.pageableResult.getItems().length && this.pageableResult.getItems().length > 1;
  }

  hasAccessToViewFinancialStatement(): boolean {
    return this.userService.getLoggedUser().hasPermission(UserPermissions.SearchFinancialStatement);
  }

  storageSearchPreferences(fiscalNumber: string): void {
    this.userService.setUserPreferences(fiscalNumber ? fiscalNumber.replace(/[./-]/g, "") : "");
    this.userProfile = this.userService.getUserProfile();
  }

  getCompanyList(): Company[] {
    return this.pageableResult.getItems() as Company[];
  }
}
